import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import postulacionesParaAdminsServices from '../../services/postulacionesParaAdminsServices';
import resourcesServices from '../../services/resourcesServices';
import { InputContext } from '../../contexts/InputContext';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import { Button, Modal, Form } from 'react-bootstrap';
import {useReactToPrint} from 'react-to-print';
import TextAreaControl from '../../container/customizedInputs/TextAreaControl';
import TextControl from '../../container/customizedInputs/TextControl';
import { errorClassification } from '../../errorHandler';

// REPORTES
import PostulantesPorOferta from '../../container/reportes/PostulantesPorOferta';

const ListaPostulacionesPorOfertas = () => {

  let { oferta_id } = useParams();

  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const postulanteToPrintRef = useRef();
  const handlePrintPostulante = useReactToPrint({
    content: () => postulanteToPrintRef.current,
  })

  const [postulaciones, setPostulaciones] = useState([]);
  const [ofertas, setOfertas] = useState([]);
  const [oferta, setOferta] = useState({});
  const [estados, setEstados] = useState([]);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [adjuntos, setAdjuntos] = useState([]);
  const [postulacionSeleccionada, setPostulacionSeleccionada] = useState({});
  const [renderPostulante, setRenderPostulante] = useState(false);
  const [renderHTML, setRenderHTML] = useState(false);
  const [header, setHeader] = useState([]);
  const [saving, setSaving] = useState(false);

  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [query, setQuery] = useState("");


  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };
  
  // modal messages B
  const [showModalB, setShowModalB] = useState(false);

  const handleShowModalB = (indice) => {
    setPostulacionSeleccionada(postulaciones[indice])
    setShowModalB(true)
  };
  const handleCloseModalB = () => { setShowModalB(false); };

  useEffect(() => {
    setRenderPostulante(Object.keys(postulacionSeleccionada).length > 0)
  }, [postulacionSeleccionada]);

  useEffect(() => {
    obtenerPostulacionesPorOferta('', {oferta_id: oferta_id, estado: estadoSeleccionado})
  }, [estadoSeleccionado]);
  

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin' || authInformation.rol === 'Veedor' || authInformation.rol === 'Jurado')){
      setRenderHTML(true)
      if(oferta_id){
        obtenerEstados()
        obtenerPostulacionesPorOferta('', {oferta_id: oferta_id, estado: estadoSeleccionado})
        fetchOferta(oferta_id)
        
      } else {
        obtenerOfertas()
      }
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Registrado')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation, oferta_id]);


  const obtenerPostulacionesPorOferta = async (sortBy='', query={}, page=1, otro='') => {
    try {
      setSaving(true)
      const data = await resourcesServices.obtenerResources('postulaciones', sortBy, query, page, otro);

      setPostulaciones(data.data);
      setHeader(data.headers);
      setSaving(false)

    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      alert(result.message)
    }
  };

  const reportePostulacionesPorOferta = async () => {
    try {
      setSaving(true)
      const data = await resourcesServices.descargarResources('postulaciones', '', {oferta_id: oferta_id, estado: estadoSeleccionado, reporte: 1});

      console.log(data.data);
      setSaving(false)

    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      alert(result.message)
    }
  };

  const obtenerOfertas = async (sortBy='') => {
    try {
      setSaving(true)
      const data = await resourcesServices.obtenerResources('ofertas');

      setOfertas(data.data);
      setSaving(false)
    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      alert(result.message)
    }
  };

  const fetchOferta = async (id) => {
    try {
      setSaving(true)
      const data = await resourcesServices.obtenerResourcePorId('ofertas', id);
      setOferta(data);
      setSaving(false)

    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const actualizarPostulacion = async () => {
    try {
      if(window.confirm(`Está seguro que quiere actualizar la información?`)){
        setSaving(true)

        const formData =  new FormData();
        formData.append('postulacion[estado]', postulacionSeleccionada.estado)
        formData.append('postulacion[comentarios]', postulacionSeleccionada.comentarios || '')
        formData.append('postulacion[antecedentes]', postulacionSeleccionada.antecedentes)
        formData.append('postulacion[examen_escrito]', postulacionSeleccionada.examen_escrito)
        formData.append('postulacion[examen_oral]', postulacionSeleccionada.examen_oral)
        formData.append('postulacion[coloquio]', postulacionSeleccionada.coloquio)

        if (adjuntos.length > 0 && adjuntos[0].length > 0) {
            for(let i = 0; i < adjuntos.length; i++){
              formData.append('postulacion[adjuntos_puntaje][]', adjuntos[i][0], adjuntos[i][0].name)
            }
        }

        const data = await postulacionesParaAdminsServices.actualizarPostulacion(postulacionSeleccionada.id, formData, true);
        setPostulacionSeleccionada(data)
        setSaving(false)
        setAdjuntos([])
        alert("Datos actualizados")
        // obtenerPostulacionesPorOferta();
      }

    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  }

  const obtenerEstados = async () => {
    try {
      const data = await postulacionesParaAdminsServices.obtenerEstados();

      setEstados(data);
    } catch (error) {
      const result = errorClassification(error)
      alert(result.message)
    }
  };

  const eliminarPostulacion = async (postulacion) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar la postulación de ${postulacion.usuario.nombre}?`)){

        await postulacionesParaAdminsServices.eliminarPostulacion(postulacion.id);

        setPostulaciones([...postulaciones].filter((psts) => psts.id !== postulacion.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const orderBy = (e, indice) => {
    e.preventDefault()

    if (sortedColumn === indice) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(indice);
      setSortOrder("asc");
    }
  }


  const handleInput = (e) => {
    e.persist();
    const { name, value } = e.target;

    setPostulacionSeleccionada({...postulacionSeleccionada,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    actualizarPostulacion()
  }

  const handleInputAdjuntos = (e) => {
    const { name, files } = e.target;
    setAdjuntos([...(adjuntos || []), files]);

    e.target.value = '';
  }  

    const eliminarAdjunto = async (idx) => {
        if(!window.confirm("Está seguro ?")){
            return;
        }

        setAdjuntos(adjuntos.filter((_, i) => i !== idx));
    }


  const eliminarAdjuntoPuntaje = async (id, adjunto_id) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar el adjunto?`)){
        const data = await postulacionesParaAdminsServices.eliminarAdjuntoPuntaje(id, adjunto_id);
        setPostulacionSeleccionada(data)
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const convertToTitleCase = (str) => {
    if(str){
      return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    }
  }

  const generarReportePostulaciones = async () => {
    const blob = await pdf( <PostulantesPorOferta oferta={oferta} postulaciones={postulaciones} estados={estados} estadoSeleccionado={estadoSeleccionado} /> ).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank'); // Abre el PDF en una nueva pestaña
  };


  return (
    <>
      <div >
      <h1>Lista de postulaciones por concurso
      {oferta_id && (
        <>
        <Link className="btn btn-secondary ms-3" to={`/listaPostulacionesPorOferta`}>Volver</Link>
        <button type='button' disabled onClick={()=>reportePostulacionesPorOferta()} className="btn btn-primary ms-3">Reporte Excel</button>
        </>
      )}
      </h1>
      
      {
        (renderHTML) && (
          <>
          <div className="table-responsive small">
            {
              saving ? (<>
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </>) :
              (<>
              {
                oferta_id ? 
                  (<div className='p-1'>

                    <div className='text-center mb-3'>
                      <div className="btn-group" role="group">
                        {
                          (authInformation.rol === 'Jurado'
                            ? estados.filter(e => !['nuevo', 'en_revision'].includes(e))
                            : estados
                          ).map((estado, idx) => (
                            <button
                              key={idx}
                              onClick={() => setEstadoSeleccionado(estado)}
                              disabled={estadoSeleccionado === estado}
                              className="btn btn-warning"
                              type="button"
                            >
                              {estado}
                            </button>
                          ))
                        }

                        <button onClick={() => setEstadoSeleccionado('')} disabled={estadoSeleccionado === ''} className='btn btn-warning' type='button'>TODOS</button>
                      </div>
                    </div>

                    <h4>{oferta.titulo} <span className="badge fs-6 bg-secondary">{convertToTitleCase(oferta.tipos)}</span></h4>
                    <table className="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th className='' scope="col">Nombre</th>
                          <th className='' scope="col">Documento</th>
                          <th className='' scope="col">Email</th>
                          <th className='' scope="col">Estado</th>
                          <th className='' scope="col">Puntaje</th>
                          <th className='' scope="col">Fecha de Postulación</th>
                          <th className='' scope="col">Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          postulaciones.map((postulacion, idx) => {
                            return (
                              <tr className='text-start' key={idx}>
                                <td>
                                  <b>{postulacion.usuario && postulacion.usuario.apellido}</b>, {postulacion.usuario && postulacion.usuario.nombre}
                                </td>
                                <td>{postulacion.documento_publico_de_usuario}</td>
                                <td>{postulacion.usuario && postulacion.usuario.email}</td>
                                <td>{postulacion.estado}</td>
                                <td>{postulacion.puntaje}</td>
                                <td>{postulacion.fecha_postulacion}<br />({postulacion.dias_desde_fecha_postulacion} días atrás)</td>
                                <td>
                                  <button className="btn btn-primary me-2" type="button" onClick={() => handleShowModalB(idx)}>Ver</button>
                                  {/* {
                                  // una vez el jurado cambio el estado a admisible, el admin no puede cambiar el estado
                                  authInformation.rol === 'Admin' && (
                                    <button disabled={postulacion.estado==3} className="btn btn-danger" onClick={()=>eliminarPostulacion(postulacion)} >Eliminar</button>
                                  )} */}
                                </td>
                              </tr>
                            )
                          })
                        }

                      </tbody>
                    </table>
                    <div className='text-end'>
                      <button className="btn btn-dark btn-lg px-4" type="button" onClick={() => generarReportePostulaciones()} >Imprimir</button>
                    </div>                  
                  </div>) 
                : 
                  (<>
                    <table className="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th className='' scope="col">Concurso</th>
                          <th className='' scope="col">Tipo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          ofertas.map((oferta, idx) => {
                            return (
                              <tr className='text-end' key={idx}>
                                <td className='text-start'>
                                  <Link className="btn btn-link" to={`/listaPostulacionesPorOferta/${oferta.id}`}>{oferta.titulo}</Link>{' '}
                                  
                                </td>
                                <td>
                                  {oferta.tipos}
                                </td>
                              </tr>
                            )
                          })
                        }

                      </tbody>
                    </table>
                  </>)
              }
              </>)
            }


          </div>
          </>
        )
      }
      </div>

      <Modal size="xl" backdrop="static" keyboard={false} show={showModalB} onHide={() => handleCloseModalB()} >
        <Modal.Header closeButton>
          <Modal.Title>{renderPostulante && (`${postulacionSeleccionada.usuario.nombre} ${postulacionSeleccionada.usuario.apellido}`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <pre>{JSON.stringify(adjuntos, null, 2)}</pre> */}
          {
            renderPostulante && (
              <div ref={postulanteToPrintRef}>
                <h1>{postulacionSeleccionada.oferta.titulo}</h1>
                <h5>Fecha de postulación: {postulacionSeleccionada.fecha_postulacion} <span className='badge bg-secondary'> {postulacionSeleccionada.dias_desde_fecha_postulacion} días</span></h5>
                <h5>Última actualización: {postulacionSeleccionada.fecha_actualizacion}</h5>

                <hr />
                <div className='row mb-3'>
                  <div className='col-sm-6'>
                    <b>Nombre:</b> {postulacionSeleccionada.usuario.nombre}
                  </div>
                  <div className='col-sm-6'>
                    <b>Apellido:</b> {postulacionSeleccionada.usuario.apellido}
                  </div>
                  <div className='col-sm-6'>
                    <b>Documento:</b> {postulacionSeleccionada.usuario.documento_identidad}
                  </div>
                  <div className='col-sm-6'>
                    <b>Email:</b> {postulacionSeleccionada.usuario.email}
                  </div>
                </div>
                {/* <hr />
                <b>Estado de condiciones:</b> {postulacionSeleccionada.estado_condiciones} */}
                <hr />
                <div>
                  {
                    postulacionSeleccionada.adjuntos_postulaciones.length > 0 && (
                      <h5>Archivos adjuntos</h5>
                    )
                  }
                  {
                    postulacionSeleccionada.adjuntos_postulaciones.map((adjunto, index) => (
                      <a key={index} href={adjunto.archivoUrl} target="_blank" className="btn btn-info me-3" role="button" aria-disabled="true">{adjunto.documentacion.nombre}</a>
                    ))
                  }
                </div>
                {
                  (authInformation.rol === 'Admin' || authInformation.rol === 'Jurado') && (
                    <Form onSubmit={handleFormSubmit}>
                      <div className='mb-3'>
                        <Form.Group>
                          {
                            // una vez el jurado cambio el estado a admisible, el admin no puede cambiar el estado
                            estados && estados.map((estado, idx) => (
                              <Form.Check
                                key={idx}
                                inline
                                value={estado}
                                label={estado}
                                name="estado"
                                type="radio"
                                disabled={authInformation.rol === 'Jurado'}
                                id={"grupo"+(idx+1)}
                                onChange={handleInput}
                                checked={postulacionSeleccionada.estado == estado}
                              />
                            ))
                          }
                        </Form.Group>
                      </div>
                      <div className='alert alert-primary mb-3' role='alert'>
                          Puede enviar cualquier notificación al postulante enviando un email a <b>{postulacionSeleccionada.usuario.email}</b>.
                      </div>
                      <div className='mb-3'>
                        <TextAreaControl
                            value={postulacionSeleccionada.comentarios}
                            name={'comentarios'}
                            disabled={authInformation.rol === 'Jurado'}
                            handleInput={handleInput}
                          />
                      </div>
                      {
                        (authInformation.rol === 'Jurado' || authInformation.rol === 'Admin') ? (
                          <>
                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.antecedentes}
                                      name={'antecedentes'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.examen_escrito}
                                      name={'examen_escrito'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.examen_oral}
                                      name={'examen_oral'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                                <div className='col-sm-3'>
                                  <TextControl
                                      value={postulacionSeleccionada.coloquio}
                                      name={'coloquio'}
                                      handleInput={handleInput}
                                      disabled={postulacionSeleccionada.estado !== "admisible"}
                                      type={'number'}
                                    />
                                </div>
                              </div>


                            </div>
                            <div className='mb-3'>
                              <b>Puntaje Total: </b> {postulacionSeleccionada.puntaje}
                              {/* <TextControl
                                  value={postulacionSeleccionada.puntaje}
                                  name={'puntaje'}
                                  handleInput={handleInput}
                                  disabled={postulacionSeleccionada.estado != 4}
                                  type={'number'}
                                /> */}
                            </div>
                            <div className='mb-3'>
                              <input
                                placeholder="Adjunte los archivos"
                                className="form-control"
                                onChange={(e) => handleInputAdjuntos(e)}
                                name="adjuntos_puntaje"
                                type="file"
                                multiple={true}
                                id={`adjuntos_puntaje`}
                              />
                            <div className="mb-3">
                                {
                                    adjuntos.map((archivo, idx) => (
                                        <div key={idx}>
                                            {archivo[0].name} <button onClick={()=>eliminarAdjunto(idx)} className="btn btn-sm active ms-2" type="button">x</button>
                                        </div>
                                    ))
                                }
                            </div>
                            </div>
                            <div className='mb-3'>
                              {
                                postulacionSeleccionada.archivos_adjuntos_puntaje.map(adjunto => (
                                  <div key={adjunto.id}>
                                    <div className="btn-group" role="group">
                                    <a href={adjunto.url} target="_blank" className="btn btn-primary" role="button" aria-disabled="true">Descargar {adjunto.nombre}</a>
                                    <button className='btn btn-danger' onClick={() => eliminarAdjuntoPuntaje(postulacionSeleccionada.id, adjunto.id)} type='button'>Eliminar</button>
                                    </div>
                                  </div>
                                ))
                              }
                            </div>


                          </>
                        ) : (
                          postulacionSeleccionada.puntaje > 0 && (
                            <h6>Puntaje: {postulacionSeleccionada.puntaje}</h6>
                          )
                        )
                      }
                      {
                        postulacionSeleccionada.puntaje > 0 && postulacionSeleccionada.usuario_puntaje && (
                          <>
                          <h6>Usuario Puntuador: {`${postulacionSeleccionada.usuario_puntaje.nombre} ${postulacionSeleccionada.usuario_puntaje.apellido}`}</h6>
                          <h6>Fecha Puntuación: {`${postulacionSeleccionada.fecha_puntaje}`}</h6>
                          </>
                        )
                      }
                      <button className='btn btn-primary' type="submit" >Guardar</button>
                    </Form>
                  )
                }



              </div>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={() => handlePrintPostulante()}>
            Imprimir
          </Button>
          <Button variant="secondary" onClick={() => handleCloseModalB(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      </>

  );
};

export default ListaPostulacionesPorOfertas;